import {
  Flex,
  IconCheckLine,
  IconClockLine,
  Pill,
  Text,
} from "@instructure/ui";
import { useTranslation } from "react-i18next";

const ExternalJuriedStatusIndicator = ({ jaComplete, hasAssessors = true }) => {
  const { t } = useTranslation();

  return (
    <Flex wrap="wrap" gap="small">
      <Flex.Item>
        {jaComplete ? (
          <Pill color="success" renderIcon={<IconCheckLine />}>
            {t("results.completed")}
          </Pill>
        ) : (
          <Pill color="warning" renderIcon={<IconClockLine />}>
            {t("results.juriedNotCompleted")}
          </Pill>
        )}
      </Flex.Item>
      {!jaComplete && (
        <Flex.Item>
          <Text color="secondary" as="div">
            {!hasAssessors
              ? t("results.juriedNoAssessors")
              : t("results.juriedPendingMessage")}
          </Text>
        </Flex.Item>
      )}
    </Flex>
  );
};

export default ExternalJuriedStatusIndicator;
